import { render, staticRenderFns } from "./SuzukaParts.vue?vue&type=template&id=80c06df4&scoped=true"
import script from "./SuzukaParts.vue?vue&type=script&lang=ts"
export * from "./SuzukaParts.vue?vue&type=script&lang=ts"
import style0 from "./SuzukaParts.vue?vue&type=style&index=0&id=80c06df4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c06df4",
  null
  
)

export default component.exports